'use strict';

import { Entity } from './Entity';

export class Company extends Entity {
  protected companyId;
  protected companyName;
  protected companyPolicyType;
  protected companyRenewalPayment;
  protected companyOrg;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.companyId = data.companyId;
    this.companyName = data.companyName;
    this.companyPolicyType = data.companyPolicyType;
    this.companyRenewalPayment = data.companyRenewalPayment;
    this.companyOrg = data.companyOrg;
  }

  public getCompanyId() {
    return this.companyId;
  }

  public getCompanyName() {
    return this.companyName;
  }

  public getCompanyPolicyType() {
    return this.companyPolicyType;
  }

  public getCompanyRenewalPayment() {
    return this.companyRenewalPayment;
  }

  public getCompanyOrg() {
    return this.companyOrg;
  }
}
